var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-list-item',{on:{"click":function($event){return _vm.sharePost(_vm.id)}}},[_c('v-list-item-title',[_c('v-icon',[_vm._v("mdi-share-variant-outline")]),_vm._v(" Поделиться ")],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }